import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { WindowInformation } from '../services/window-information';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

interface ContentContainerProps {
    children: React.ReactNode | undefined;
    style?: StyleProp<ViewStyle>;
    headerHeight: number;
}

export default function ContentContainer(props: ContentContainerProps) {
    const windowInfo = WindowInformation();
    const insets = useSafeAreaInsets();

    return (
        <View
            style={[{
                width: '100%',
                height: windowInfo.height - props.headerHeight - insets.top - insets.bottom,
                paddingHorizontal: 16,
                paddingVertical: 8,
            }, props.style]}
        >
            {props.children}
        </View>
    );
}
